export default __webpack_public_path__ + "static/media/third_order.5b5ea072.svg";